import { Box, CircularProgress } from "@mui/material";

// Suspense fallback for lazy-loaded pages: a spinner centered in all the space
// the page would take. `height` defaults to filling the parent; pass "100vh"
// when the parent has no fixed height (e.g. outside <Layout>).
const PageLoadingFallback = ({ height = "100%" }: { height?: string }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height,
    }}
  >
    <CircularProgress />
  </Box>
);

export default PageLoadingFallback;
